import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Caption from 'LuxKit/Typography/Caption'
import { mediaQueryUp } from 'components/utils/breakpoint'
import useMerchandiseTopBrands from 'hooks/Merchandise/useMerchandiseTopBrands'
import useMerchandiseTopCategories from 'hooks/Merchandise/useMerchandiseTopCategories'
import { take } from 'lib/array/arrayUtils'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import MerchandiseSearchFormResultItem from './MerchandiseSearchFormResultItem'
import useMerchandiseList from 'hooks/Merchandise/useMerchandiseList'
import Group from 'components/utils/Group'

const ResultsGrid = styled.div`
  display: grid;

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
    gap: ${rem(40)}
  }
`

interface Props {
  text: string;
}

function MerchandiseSearchFormNoResults(props: Props) {
  const { text } = props

  const [brands] = useMerchandiseTopBrands()
  const [categories] = useMerchandiseTopCategories()
  const [offers] = useMerchandiseList({
    sortBy: 'recommended',
  })

  return <Group direction="vertical" gap={20} tabletGap={24}>
    <Caption variant="large">
      Oops! We don't have any products, brands or categories related to "{text}"
      <br /><br />
      Try a different search term of browse our bestsellers below.
    </Caption>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended products</Caption>
      <ResultsGrid>
        {take(offers, 3).map(merchandiseId => (
          <MerchandiseSearchFormResultItem
            key={merchandiseId}
            itemId={merchandiseId}
            type="product"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended categories</Caption>
      <ResultsGrid>
        {take(categories, 3).map(category => (
          <MerchandiseSearchFormResultItem
            key={category.id}
            itemId={category.id}
            type="category"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
    <VerticalSpacer gap={8}>
      <Caption variant="large" weight="bold">Recommended brands</Caption>
      <ResultsGrid>
        {take(brands, 3).map(brand => (
          <MerchandiseSearchFormResultItem
            key={brand.id}
            itemId={brand.id}
            type="brand"
          />
        ))}
      </ResultsGrid>
    </VerticalSpacer>
  </Group>
}

export default MerchandiseSearchFormNoResults
